import {BuyBonusPopUpEvents, ReelConstants, ReelsBasicState} from '@gongxigames/framework/slot';
import {RandomWildEvents} from 'src/randomWild/RandomWildEvents';
import {GameLogic} from 'src/server/GameLogic';
import {GameReelsView} from 'src/gameReels/GameReelsView';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';

export class GameReelsBasicState extends ReelsBasicState {
    protected setupEvents(): void {
        super.setupEvents();
        this.setEventHandler(RandomWildEvents.WILD_LANDED, this.onWildLanded.bind(this));
        this.setEventHandler(RandomWildEvents.ACTIVATOR_WIN_STARTED, this.onActivatorWinStarted.bind(this));
        this.setEventHandler(RandomWildEvents.ACTIVATOR_WIN_FINISHED, this.onActivatorWinFinished.bind(this));
        this.setEventHandler(RandomWildEvents.SHOULD_START_DARKENING, this.onShouldStartDarkening.bind(this));
        this.setEventHandler(RandomWildEvents.RANDOM_WILD_FEATURE_FINISHED, this.onRandomWildFeatureFinished.bind(this));
        this.setEventHandler(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked.bind(this));
    }

    protected onSpinStartedByButton(): void {
        if (this.module.canSpinBySpinButton) {
            (this.view as GameReelsView).resetSymbols();
        }
        super.onSpinStartedByButton();
    }

    protected onBuyButtonClicked(): void {
        this.view.showAllSymbols();
    }

    protected onShouldStartDarkening(): void {
        const logic = this.module.logic as GameLogic;
        const positions = logic.getPositionsToFade();
        const randomWildPositions = logic.getRandomWildPositions();

        if (positions && positions.length > 0) {
            positions.forEach((pos) => {
                (this.view as GameReelsView).fadeSymbol(pos.reel, pos.row);
            });
            randomWildPositions.forEach((pos) => {
                (this.view as GameReelsView).fadeSymbol(pos.reel, pos.row);
            });
        }
    }

    protected onRandomWildFeatureFinished(): void {
        this.view.showAllSymbols();
    }

    protected onWildLanded(reelIndex: number, rowIndex: number): void {
        (this.view as GameReelsView).onWildLanded(reelIndex, rowIndex);
    }

    protected onActivatorWinStarted(): void {
        const spin = (this.module.logic.spinData as WolfHavenSpin);
        const symbolIds = spin.symbolIds;
        const lastReelIndex = ReelConstants.REELS_AMOUNT - 1;
        const activatorRow = symbolIds[lastReelIndex].indexOf(WolfHaven.Activator);

        this.view.hideSymbol({x: lastReelIndex, y: activatorRow});
    }

    protected onActivatorWinFinished(): void {
        const spin = (this.module.logic.spinData as WolfHavenSpin);
        const symbolIds = spin.symbolIds;
        const lastReelIndex = ReelConstants.REELS_AMOUNT - 1;
        const activatorRow = symbolIds[lastReelIndex].indexOf(WolfHaven.Activator);

        this.view.showSymbol({x: lastReelIndex, y: activatorRow});
    }
}
